import * as React from "react";
import type { SVGProps } from "react";
const SvgPending = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16" {...props}
  >
    <path fill="#D6DBE7" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1" />
    <path
      fill="#AFB6C4"
      d="M4.494 1.94a6.95 6.95 0 0 0-2.562 2.563A6.94 6.94 0 0 0 1 8h7l-.009-7a6.95 6.95 0 0 0-3.497.94"
    />
    <path fill="#041E78" d="M8 11.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7" />
  </svg>
);
export default SvgPending;
